"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./index.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-CONTAINERS [ BLOCK ] ##############################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


var Block = function Block(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      children = _ref.children,
      _ref$hasBorder = _ref.hasBorder,
      hasBorder = _ref$hasBorder === void 0 ? false : _ref$hasBorder,
      _ref$footerNav = _ref.footerNav,
      footerNav = _ref$footerNav === void 0 ? [] : _ref$footerNav,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable,
      _ref$headerContent = _ref.headerContent,
      headerContent = _ref$headerContent === void 0 ? [] : _ref$headerContent; // 2.1. FUNCTION .............................................................
  // 2.2.1. RENDER FOOTER NAV

  var renderFooterLinks = function renderFooterLinks(data) {
    return data.map(function (item, index) {
      return _react["default"].createElement("li", {
        key: index
      }, item);
    });
  }; // 2.2.1 END
  // 2.2.2. RENDER HEADER


  var renderHeader = function renderHeader(data) {
    return data.map(function (item, index) {
      return _react["default"].createElement("li", {
        key: index
      }, item);
    });
  }; // 2.2.2 END
  // 2.1. END ..................................................................
  // 2.2. RENDER COMPONENT .....................................................


  return _react["default"].createElement(_index.BlockContainer, {
    hasBorder: hasBorder
  }, title && _react["default"].createElement(_index.BlockHeader, null, _react["default"].createElement("h4", null, title), headerContent && _react["default"].createElement("ul", null, renderHeader(headerContent))), _react["default"].createElement(_index.BlockContent, {
    scrollable: scrollable
  }, children), footerNav.length > 0 && _react["default"].createElement(_index.BlockFooter, null, _react["default"].createElement("ul", null, renderFooterLinks(footerNav)))); // 2.2. END ..................................................................
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. PROP-TYPES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


Block.propTypes = {
  title: _propTypes["default"].string,
  hasBorder: _propTypes["default"].bool,
  footerNav: _propTypes["default"].array,
  scrollable: _propTypes["default"].bool,
  headerContent: _propTypes["default"].array,
  children: _propTypes["default"].node.isRequired
}; // 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

var _default = Block; // END OF FILE #################################################################

exports["default"] = _default;